import { render } from "./JobOfferLetterPreview.vue?vue&type=template&id=21a245c8&scoped=true"
import script from "./JobOfferLetterPreview.vue?vue&type=script&lang=js"
export * from "./JobOfferLetterPreview.vue?vue&type=script&lang=js"

import "./JobOfferLetterPreview.vue?vue&type=style&index=0&id=21a245c8&scoped=true&lang=css"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a245c8"]])

export default __exports__